export const CREATE_POOL_REQUEST_REQUEST = 'CREATE_POOL_REQUEST_REQUEST';

export const createPoolRequestRequest = ( poolRequestData ) => ({
    type: CREATE_POOL_REQUEST_REQUEST,
    payload: { ...poolRequestData },
});
